export default {
  title: 'Aggiornamento orario!',
  labels: {
    old_time: 'Orario ritiro precedente:',
    new_time: 'Nuovo orario di ritiro:',
  },
  buttons: {
    print: 'Stampa e chiudi',
    got_it: 'Capito',
  },
  feedback: {
    new_prep_time: "L'orario di consegna è stato aggiornato. Adegua il programma di preparazione.",
  },
  toasts: {
    something_went_wrong: 'Qualcosa è andato storto, riprova',
  },
};
